<template>
  <div class="manage-section">
    <div class="current-title">后台账号管理</div>
    <div class="search-wrap">
      <el-input v-model="search.keyword" placeholder="请输入关键词" style="width: 200px; margin-right: 10px;"></el-input>
      <el-cascader
        v-if="isSuperAdmin"
        v-model="selectedOptions"
        :options="regionData"
        :props="{ value: 'value', label: 'label', children: 'children' }"
        @change="handleChange"
        placeholder="请选择区县"
        style="width: 250px; margin-right: 10px;"
      ></el-cascader>
      <el-button type="primary" @click="getList">查询</el-button>
      <el-button type="success" @click="openAdd">新增</el-button>
    </div>
    <div class="table-wrap">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column type="index" label="序号" width="60"></el-table-column>
        <el-table-column prop="account" label="账号"></el-table-column>
        <el-table-column prop="role" label="角色">
          <template slot-scope="scope">
            {{ roleMap[scope.row.role] || scope.row.role }}
          </template>
        </el-table-column>
        <el-table-column prop="districtName" label="所属区县"></el-table-column>
        <el-table-column prop="status" label="状态">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.status == 1" type="success">启用</el-tag>
            <el-tag v-else type="danger">停用</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间"></el-table-column>
        <el-table-column label="操作" width="180">
          <template slot-scope="scope">
            <el-button size="mini" @click="openEdit(scope.row)">编辑</el-button>
            <el-button size="mini" type="danger" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pager-wrap">
      <el-pagination
        background
        @current-change="handleCurrentChange"
        :current-page="search.pageIndex"
        :page-size="search.pageSize"
        layout="total, prev, pager, next"
        :total="totalCount"
      ></el-pagination>
    </div>

    <add-or-edit-backend-user
      :visible.sync="dialogVisible"
      :data="currentRow"
      @success="getList"
    />
  </div>
</template>

<script>
import { regionData, CodeToText } from "element-china-area-data";
import addOrEditBackendUser from "./components/addOrEditBackendUser.vue";

export default {
  components: { addOrEditBackendUser },
  data() {
    return {
      regionData: regionData,
      selectedOptions: [],
      isSuperAdmin: false,
      roleMap: {
        SUPER_ADMIN: "超级管理员",
        ADMIN: "管理员",
        STAFF: "工作人员"
      },
      search: {
        keyword: "",
        province: "",
        city: "",
        district: "",
        pageIndex: 1,
        pageSize: 10
      },
      tableData: [],
      totalCount: 0,
      dialogVisible: false,
      currentRow: null
    };
  },
  created() {
    this.initDistrict();
    this.getList();
  },
  methods: {
    initDistrict() {
      const userInfoStr = localStorage.getItem("adminUserInfo");
      if (userInfoStr) {
        const userInfo = JSON.parse(userInfoStr);
        this.isSuperAdmin = userInfo.role === "SUPER_ADMIN";
        if (!this.isSuperAdmin) {
          this.search.province = userInfo.provinceId || "";
          this.search.city = userInfo.cityId || "";
          this.search.district = userInfo.districtId || "";
          if (this.search.province && this.search.city && this.search.district) {
            this.selectedOptions = [this.search.province, this.search.city, this.search.district];
          }
        }
      }
    },
    handleChange(value) {
      this.search.province = value[0] || "";
      this.search.city = value[1] || "";
      this.search.district = value[2] || "";
    },
    getList() {
      this.$apis.get("/admin/backendUser/page", this.search).then(res => {
        if (res.data.code == 200) {
          this.tableData = res.data.data.list || [];
          this.totalCount = res.data.data.totalCount || 0;
        } else {
          this.$message.error(res.data.msg || "查询失败");
        }
      });
    },
    handleCurrentChange(val) {
      this.search.pageIndex = val;
      this.getList();
    },
    openAdd() {
      this.currentRow = null;
      this.dialogVisible = true;
    },
    openEdit(row) {
      this.currentRow = row;
      this.dialogVisible = true;
    },
    handleDelete(row) {
      this.$confirm("确认删除该账号？", "提示", { type: "warning" }).then(() => {
        this.$apis.post("/admin/backendUser/delete", { id: row.id }).then(res => {
          if (res.data.code == 200) {
            this.$message.success("删除成功");
            this.getList();
          } else {
            this.$message.error(res.data.msg || "删除失败");
          }
        });
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/page/backendUserManage.vue